"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _Radio = _interopRequireDefault(require("./Radio.style"));

var _Label = _interopRequireDefault(require("../Label"));

var _dec, _class;

let Radio = (_dec = (0, _reactJss.default)(_Radio.default), _dec(_class = class Radio extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    const {
      id,
      visibility,
      onChange
    } = this.props;
    if (visibility === 'disabled') return;
    const error = false;
    onChange({
      id,
      value,
      error
    });
  }

  render() {
    const _this$props = this.props,
          {
      id,
      classes,
      className,
      helperText,
      error,
      value,
      children,
      visibility,
      align,
      label: labelProp,
      dataTestId
    } = _this$props,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["id", "classes", "className", "helperText", "error", "value", "children", "visibility", "align", "label", "dataTestId"]);
    let label = labelProp;

    if (label) {
      label = (0, _react.isValidElement)(label) ? label : /*#__PURE__*/_react.default.createElement("div", {
        className: classes.label
      }, label);
    }

    return (
      /*#__PURE__*/
      // Because onChange is already used in handleChange
      _react.default.createElement("div", (0, _extends2.default)({}, _utils.default.omit(rest, ['onChange']), {
        "data-testid": dataTestId ? `${dataTestId}-container` : undefined
      }), visibility !== 'hidden' ? label : null, /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        className: (0, _clsx.default)(className, classes.radio, {
          hidden: visibility === 'hidden'
        }, {
          disabled: visibility === 'disabled'
        }, {
          horizontal: align === 'horizontal'
        }),
        "data-testid": dataTestId
      }, _react.default.Children.map(children, child => _react.default.cloneElement(child, {
        className: classes.item,
        activeItem: value,
        onChange: this.handleChange
      })), helperText && /*#__PURE__*/_react.default.createElement(_Label.default, {
        className: (0, _clsx.default)(classes.helperText, {
          error
        }),
        value: helperText,
        fontSize: "small",
        error: error
      })))
    );
  }

}) || _class);
Radio.defaultProps = {
  id: null,
  value: null,
  visibility: 'visible',
  align: 'vertical',
  error: false,
  onChange: () => {}
};
var _default = Radio;
exports.default = _default;